import RequestPageTwo from "./RequestPageTwo";

const MaintenanceFundReq = () => {
    return (
        <RequestPageTwo title="Maintenance Fund Request"
            fetchUrl="/get-maintenance-fund-requests"
            editEndpoint="update-maintenance-fund-requests"
            deleteEndpoint="maintenance-fund-requests"
            statusEndpoint="update-maintenance-fund-requests" />
    );
}

export default MaintenanceFundReq;
